module.exports = __webpack_public_path__ + "static/media/BCDR.404f66e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/BCDR.jpg
// module id = 1712
// module chunks = 1